import { render, staticRenderFns } from "./TableFooterContainer.vue?vue&type=template&id=5f440124&scoped=true&"
import script from "./TableFooterContainer.vue?vue&type=script&lang=ts&"
export * from "./TableFooterContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f440124",
  null
  
)

export default component.exports